import { Navigate, Route, Routes, useParams } from "react-router-dom";
import PUBLIC_ROUTES from "./publicRoutes";
import PROTECTED_ROUTES from "@/routes/protectedRoutes";
import { withAuth } from "@/hoc/withAuth";
import { RouteLayout } from "@/components/layout/Layout";
import usePathWithSlug from "@/hooks/usePathWithSlug";

function GrantsRedirect() {
  const { "*": path } = useParams();
  const pathWithSlug = usePathWithSlug();
  return <Navigate to={pathWithSlug(`/programs/${path}`)} replace />;
}

function SlugIndexRedirect() {
  const pathWithSlug = usePathWithSlug();
  return <Navigate to={pathWithSlug("/")} replace />;
}

function _Routes() {
  const publicRoutes = PUBLIC_ROUTES.map(({ path, component: Component, meta }) => (
    <Route key={path} path={path} {...meta} element={<Component />} />
  ));

  const protectedRoutes = PROTECTED_ROUTES.map(({ path, component }) => {
    const Component = withAuth(component);
    return <Route key={path} path={path} element={<Component />} />;
  });

  const publicRoutesNested = PUBLIC_ROUTES.map(({ path, component: Component }) => {
    const relativePath = path.startsWith("/") ? path.slice(1) : path;
    if (relativePath === "") {
      return <Route key={`x-index`} index element={<Component />} />;
    }
    return <Route key={`x-${path}`} path={relativePath} element={<Component />} />;
  });

  const protectedRoutesNested = PROTECTED_ROUTES.map(({ path, component }) => {
    const Component = withAuth(component);
    const relativePath = path.startsWith("/") ? path.slice(1) : path;
    if (relativePath === "") {
      return <Route key={`x-protected-index`} index element={<Component />} />;
    }
    return <Route key={`x-${path}`} path={relativePath} element={<Component />} />;
  });

  return (
    <Routes>
      <Route path="/grants/*" element={<GrantsRedirect />} />
      <Route path="*" element={<Navigate to="/" replace />} />

      <Route path="/" element={<RouteLayout />}>
        {publicRoutes}
        {protectedRoutes}
      </Route>

      <Route path="/x/:slug/*" element={<RouteLayout />}>
        {publicRoutesNested}
        {protectedRoutesNested}
        <Route path="*" element={<SlugIndexRedirect />} />
      </Route>
    </Routes>
  );
}

export default _Routes;
